export function fileSize(input) {
    if (typeof input !== "number") {
        return "";
    }
    if (input < 1000) {
        return `${input}B`;
    }
    else if (input < 1000000) {
        return `${(input / 10000).toFixed(2)}kB`;
    }
    else if (input < 1000000000) {
        return `${(input / 1000000).toFixed(2)}MB`;
    }
    else if (input < 1000000000000) {
        return `${(input / 1000000000).toFixed(2)}GB`;
    }
    else {
        return `${(input / 1000000000000).toFixed(2)}TB`;
    }
}
export function fileDate(input) {
    return input.toLocaleString();
}
